
    var riot = require('riot')
    
riot.tag2('signup', '<div class="profile"> <div class="row"> <div class="col-xs-12"> <form onsubmit="{handleSaveProfile}" hide="{status==\'success\'}" class="form-horizontal"> <forminput name="first_name" label="First Name" onupdate="{handleUpdate}" value="{user.first_name}" width1="3" width2="9" isrequired=""></forminput> <forminput name="surname" label="Surname" onupdate="{handleUpdate}" value="{user.surname}" width1="3" width2="9" isrequired=""></forminput> <formcheckbox name="is_student" label="I am a Student, currently studying, with an official university email address" onupdate="{handleUpdate}" value="{user.is_student}" width1="3" width2="9"></formcheckbox> <forminput name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="3" width2="9" isrequired=""></forminput> <div show="{user.is_student==true}" class="col-xs-9 col-xs-offset-3"> <alert bsstyle="warning">Please ensure you enter your valid university email address above</alert> </div> <forminput if="{user.is_student!=true &amp;&amp; !user.referral}" name="company" label="Company" onupdate="{handleUpdate}" value="{user.company}" width1="3" width2="9" isrequired="{user.is_student!=true}"></forminput> <forminput name="city" label="City" onupdate="{handleUpdate}" value="{user.city}" width1="3" width2="9" isrequired=""></forminput> <forminput name="postcode" label="Postcode / Zipcode" onupdate="{handleUpdate}" value="{user.postcode}" width1="3" width2="9" isrequired=""></forminput> <formselect name="country" label="Country" onupdate="{handleUpdate}" value="{user.country}" options="{countryCodes}" default="Select Country" width1="3" width2="9" isrequired=""></formselect> <div class="row"> <div class="col-xs-9 col-xs-offset-3"> <button type="submit" __disabled="{disabled}" class="btn btn-primary"> <span show="{disabled}" class="fa fa-refresh fa-spin"> </span> Sign Up</button> </div> </div> <p><br></p> </form> <div if="{message}" class="alert {\'alert-\'+status}"> {message} <button onclick="{clearmessage}" class="close">&times;</button> </div> </div> </div> </div>', '', '', function(opts) {
var Resource, countryApi, xhr;

xhr = require("../libs/xhr.coffee");

Resource = require('riot-kit/utils/apiResource.coffee');

countryApi = new Resource(opts.countrysrc || '/duocms/api/countries', true);

this.on("mount", function() {
  var params;
  params = new URLSearchParams(window.location.search);
  this.user = {
    referral: params.get('ref')
  };
  if (window.location.search.match(/editmode=/)) {
    this.root.innerHTML = "-- signup form --";
  }
  this.countryCodes = [];
  this.disabled = false;
  return countryApi.get((function(_this) {
    return function(countries) {
      _this.countryCodes = countries.map(function(country) {
        return {
          label: country.name,
          value: country.code
        };
      });
      return _this.update();
    };
  })(this));
});

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function(e) {
    _this.update({
      disabled: true,
      message: false
    });
    e.preventDefault();
    return xhr("POST", "/duocms/api/register", _this.user, function(res) {
      var status;
      status = res.status === 200 ? "success" : "danger";
      _this.update({
        message: res.body.message || res.body.data.message,
        status: status
      });
      if (status !== "success") {
        return _this.update({
          disabled: false
        });
      }
    });
  };
})(this);

this.clearmessage = (function(_this) {
  return function() {
    return _this.update({
      message: false
    });
  };
})(this);
});
    
  